import React from 'react';
import './App.css';

function App() {
  return (
    <h1>This is the space clock!</h1>
  );
}

export default App;
